import { __awaiter, __generator } from "tslib";
import { overflowLabelViewKey } from '.';
export var createOverflowLabelViewDriver = function (wrapper) {
    var base = wrapper.$("." + overflowLabelViewKey);
    return {
        textByIdx: function (idx) { return base.$$('.visible-label-container').get(idx).text(); },
        visibleLabelsCount: function () { return base.$$('.label-container').count(); },
        isShowMore: function () { return base.$('.show-more-label').exists(); },
        showMoreText: function () { return base.$('.show-more-title').text(); },
        getTotalCount: function () { return __awaiter(void 0, void 0, void 0, function () {
            var count, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        count = 0;
                        _a = count;
                        return [4 /*yield*/, base.$$('.label-container').count()];
                    case 1:
                        count = _a + _c.sent();
                        return [4 /*yield*/, base.$('.show-more-label').exists()];
                    case 2:
                        if (!_c.sent()) return [3 /*break*/, 4];
                        count -= 1;
                        _b = count;
                        return [4 /*yield*/, base.$('.show-more-title').text()];
                    case 3:
                        count = _b + +(_c.sent());
                        _c.label = 4;
                    case 4: return [2 /*return*/, count];
                }
            });
        }); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map